@if (targetList && targetList.length > 0) {
	<div
		class="toolbox"
		draggable="true"
		[ngClass]="{ 'toolbox--expand': isExpand }"
		cdkDrag
	>
		<button
			type="button"
			class="toolbox__toggle"
			inCutVersionActive
			(click)="toggle()"
		>
			<app-svg-config></app-svg-config>
		</button>
		<div class="toolbox__inside">
			<label>
				<div class="helper-bold helper-nowrap">Выберите API:</div>
				<select
					class="toolbox__select"
					[formControl]="selectControl"
					[compareWith]="compareFn"
				>
					@for (targetItem of this.targetList; track targetItem) {
						<option
							class="toolbox__option"
							[ngValue]="targetItem"
							[title]="getTarget(targetItem)"
						>
							<div>
								<p class="toolbox__option-segment-name">
									{{ targetItem.segmentName }}
								</p>
								<!-- <p class="toolbox__option-target-item">
									{{ getTarget(targetItem) }}
								</p> -->
							</div>
						</option>
					}
				</select>
			</label>
		</div>
	</div>
}
